import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

// Questo è il blocco che hai appena copiato da Google
const firebaseConfig = {
    apiKey: "AIzaSyC4yhsq0sy00SfCt3Jk1ZCjRd7sAqgK_CY",
    authDomain: "gio360-beta.firebaseapp.com",
    projectId: "gio360-beta",
    storageBucket: "gio360-beta.firebasestorage.app",
    messagingSenderId: "199910083545",
    appId: "1:199910083545:web:2d610dc94820a5077a67c8",
    measurementId: "G-3N4RNEMSF5"
};

// Inizializzazione dei servizi verso il Cloud
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);